import type { Interval } from "./type";

export function toInterval(value: string): Interval {
  const [from, to] = value.split(",");
  const parsedFrom = parseFloat(from);
  const parsedTo = parseFloat(to);
  return {
    from: isNaN(parsedFrom) || from === "_" ? undefined : parsedFrom,
    to: isNaN(parsedTo) || to === "_" ? undefined : parsedTo,
  };
}

export function hasLessLowerLimitThanOrEqual(value: Interval, other: Interval): boolean {
  if (!other.from) {
    return !value.from;
  }
  return !value.from || !!(value.from && value.from <= other.from);
}

export function hasGreaterUpperLimitThanOrEqual(value: Interval, other: Interval): boolean {
  if (!other.to) {
    return !value.to;
  }
  return !value.to || !!(value.to && value.to >= other.to);
}

export function isOverlapped(value: Interval, compare: Interval): boolean {
  return (
    (value.from && value.to && compare.from && compare.to && value.from >= compare.from && value.to <= compare.to) ||
    (!compare.from && compare.to && value.to && value.to <= compare.to) ||
    (!compare.to && compare.from && value.from && value.from >= compare.from) ||
    false
  );
}
